import { motion } from 'framer-motion';

const Modal = ({ isOpen, onClose, title, message }) => {
  if (!isOpen) return null;

  return (
    <motion.div
      className="fixed inset-0 bg-[#000300] bg-opacity-50 flex items-center justify-center z-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <div className="bg-gray-50 rounded-lg p-6 shadow-lg w-full max-w-md text-[#000300]">
        <h2 className="text-xl font-semibold mb-4">{title}</h2>
        <p className="text-[#000300] mb-6">{message}</p>
        <div className="text-right">
          <button
            onClick={onClose}
            className="bg-[#000300] text-white py-2 px-4 rounded hover:bg-[#000300] transition"
          >
            Close
          </button>
        </div>
      </div>
    </motion.div>
  );
};
export default Modal;